import { Component, OnInit, ViewChild, EventEmitter, ElementRef, AfterViewInit } from '@angular/core';
import { AzureFunctionsService, Status, Subscription, ProcessStatusEnum, IProcess, ProcessStatusEnumNames, OnboardingProcessModel } from 'src/app/azurefunctions/azure-functions.service';
import { MsalService } from '@azure/msal-angular';
import { AzureadHelperService } from 'src/app/azuread/azuread-helper.service';
import { WizardStep, Wizard, WizardStepWithErrorPipe } from 'src/app/shared/wizard.service';
import { SubscriptionChooserModal } from '../subscription-chooser-modal/subscription-chooser-modal.component';
import { environment } from 'src/environments/environment';
import { ConfigLoaderService } from 'src/app/shared/config-loader.service';

export enum OnboardingLoadingStatus{
  DataLoading, AppConsent, CheckPermissions, Loaded
}

@Component({
  selector: 'app-start-onboarding',
  templateUrl: './start-onboarding.component.html',
  styleUrls: ['./start-onboarding.component.css']
})
export class StartOnboardingComponent implements AfterViewInit {


  @ViewChild(SubscriptionChooserModal, {static: false}) 
  private chooseSubscriptionDialog: SubscriptionChooserModal;
  //chooseSubscriptionDialog: SubscriptionChooserModal;
  
  hasError: boolean;
  processStarted: boolean;
  errorMessage: string;
  editions: string[];
  
  ready: boolean;
  status: Status;
  subcription: Subscription;
  appConsentInProgress: boolean = true;
  checkingPermissionsInProgress: boolean;
  // workaround to access enums in template 
  processStatusEnum: any = ProcessStatusEnum;
  processStatusEnumNames: any = ProcessStatusEnumNames;
  onboardingLoadingStatus: any = OnboardingLoadingStatus;

  loadingStatus: OnboardingLoadingStatus;

  wizard: Wizard;
  
 
  constructor(private functionsService: AzureFunctionsService, private adHelper: AzureadHelperService, private configService: ConfigLoaderService) { }
  
  handleLoadingError = function(e){

  }

  ngAfterViewInit(){
    // first, read the process and all data
    this.functionsService.getOnboardingProcess().then((model) => {
      this.subcription = model.subscription;
      this.editions = model.editions;
      this.loadingStatus = OnboardingLoadingStatus.AppConsent;
      // request consent for the application itself to check permissions  
      this.adHelper.loginAdminConsenstPopup(this.configService.Configuration.msal.clientId).then(() => {
        this.loadingStatus = OnboardingLoadingStatus.CheckPermissions;
        this.functionsService.checkPermissions().then(() => {
          this.initSteps(model);
          this.loadingStatus = OnboardingLoadingStatus.Loaded;
        },
        () => {
          this.errorMessage = "In order to start the onboarding process, you must be the Global Admin of this tenant and you must be the owner of at least one Azure Subscription. If this is already the case, but this is the first time you run the Smart Workplace Management tool, please log out and log back in, then run the program again"
          this.loadingStatus = OnboardingLoadingStatus.Loaded;
        }
        );
      }
      , (e) => this.errorMessage = "Application consent required to continue")  
    }
    , (e) => this.errorMessage = "Unable to load applicaiton steps"
    );
  }

  initSteps(model: OnboardingProcessModel){
    let wizardSteps = [];
    for (let index = 0; index < model.process.steps.length; index++) {
      
      const step = model.process.steps[index];
      if(typeof this[step.uiFunctionName] != "function"){
          throw new Error("Unable to find function " + step.uiFunctionName);
      }
      step.handler = this[step.uiFunctionName].bind(this);
      if(step.statusDescription)
        step.error = JSON.parse(step.statusDescription);
      wizardSteps.push(step);
      //wizardSteps.push(new WizardStep(step.uiFunctionName, step.title, step.visible, this[step.uiFunctionName].bind(this), null))
    }

    this.wizard = new Wizard("onboarding", wizardSteps, this.functionsService);
    this.wizard.currentProcess = model.process;
  }

  getHandlerParams(){
    return this.subcription;
  }

  startProcess(){
    this.wizard.start();
  }

  rerunStep(){
    this.wizard.repeatFailed();
  }

  checkStatus(){
    this.status = null;
    this.hasError = false;
    this.functionsService.status().then(s => this.status = s, 
      e => {
        this.errorMessage = e.message;
      });
  }

  /*
   * Steps implementation
   */

  requestConsents(){
    return this.functionsService.runConsensts();
  }

  loadSubscriptions(){
    return new Promise((complete, reject) => {
      
      if(this.subcription.subscriptionId && this.subcription.subscriptionId.length > 0){
        complete();
        return;
      }

      return this.functionsService.subcriptions().then(subs => {
        if(subs.length == 0){
          reject("Unable to find any subscriptions for this account, please check your Azure configuration");
        }
        else if(subs.length == 1){
          this.subcription = subs[0];
          this.functionsService.executePostFunction("UpdateTargetSubscription", 
          {
            subscriptionId: this.subcription.subscriptionId, 
            subscriptionDisplayName: this.subcription.displayName
          },
          {"processId": this.wizard.currentProcess.processId}).toPromise().then(() => complete());
         
        }
        else{
          this.chooseSubscriptionDialog.open(subs).then((s) => {
            this.subcription = s;
            this.functionsService.executePostFunction("UpdateTargetSubscription", 
            {
              subscriptionId: this.subcription.subscriptionId, 
              subscriptionDisplayName: this.subcription.displayName
            },
            {"processId": this.wizard.currentProcess.processId}).toPromise().then(() => complete());
          }).catch((er) => reject(er));
        }

      }).catch((er) => {
        reject("Application was not able to load your subscriptions");
      });
    });
  }

  checkPermissions(){
    return this.functionsService.checkPermissions();
  }
  createUsers(){
    return this.functionsService.startUsersCreation(this.wizard.currentProcess.processId);
  }

  createGroups(){
    return this.functionsService.startGroupsCreation(this.wizard.currentProcess.processId);
  }

  registerServiceProviders(){
    return this.functionsService.registerResourceProviders(this.subcription, this.wizard.currentProcess.processId);
  }

  assignDirectoryRole(){
    return this.functionsService.assignDirectoryRoles(this.wizard.currentProcess.processId);
  }
  
  assignSubscriptionRoles(){
    return this.functionsService.assignSubscriptionRoles(this.subcription, this.wizard.currentProcess.processId);
  }

  createResourceGroups(){
    return this.functionsService.createResourceGroups(this.subcription, this.wizard.currentProcess.processId);
  }

  setEnterpriseOwners(){
    return this.functionsService.assignEntAppOwner(this.subcription, this.wizard.currentProcess.processId);
  }
}
